export default {
    values: Object.freeze ({
        ROOT: Symbol(1),
        ADMIN: Symbol(2),
        USER: Symbol(4),
    }),
    labels: {
        1: 'root',
        2: 'admin',
        4: 'user',
    }
}
